import Popover from "@mui/material/Popover";
import clsx from "clsx";
import React, { memo, useState } from "react";
import { CopyIcon } from "../../../../core/consts/redesign/icons/Copy";
import useIsMobile from "../../../../core/hooks/useIsMobile";
import { AgentClients, ClientTypes } from "../../../../core/types/agentTypes";
import { copyToClipboard } from "../../../../core/utils/copyToClipboard";
import IconButtonMain from "../../../../UIcomponentsRedesign/IconButtonMain/IconButtonMain";
import classes from "./ClientCard.module.scss";
type PropsType = {
  clientInfo: AgentClients;
}

const ClientCard: React.FC<PropsType> = ({
  clientInfo,
}) => {
  const [copyInnPopoverAnchor, setCopyInnPopoverAnchor] = useState<HTMLElement | null>(null);
  const [copyNamePopoverAnchor, setCopyNamePopoverAnchor] = useState<HTMLElement | null>(null);
  const isMobile = useIsMobile();
  const clientName = clientInfo.companyName;

  const clientType = ClientTypes[clientInfo.clientType];
  const region = clientInfo.region;
  const inn = clientInfo.inn;
  const time = clientInfo.localTime;
  // const userId = clientInfo.userId;
  // const clientUrl = `${ROUTES.AGENT}/clients/${userId}`;

  const handleCopyClientName = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setCopyNamePopoverAnchor(e.currentTarget);
    copyToClipboard(clientName.toString())
    setTimeout(() => {
      setCopyNamePopoverAnchor(null);
    }, 2000);
  };

  const handleCopyInn = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setCopyInnPopoverAnchor(e.currentTarget);
    copyToClipboard(inn.toString());
    setTimeout(() => {
      setCopyInnPopoverAnchor(null);
    }, 2000);
  };

  return (
    <div className={classes.card}>
      {isMobile ?
        <div className={classes.rowBox}>
          <div className={clsx(classes.colContainer, classes.nameWidth)}>
            {clientType &&
              <div className={classes.copyBox}>
                <span className={classes.grayText}>{clientType}</span>
                <IconButtonMain
                  title='Скопировать'
                  style={{ width: '16px', height: '16px' }}
                  handleClickEvent={(e) => handleCopyClientName(e)}
                  color="noBgTransparent" icon={<CopyIcon />} />
                <Popover
                  open={Boolean(copyNamePopoverAnchor)}
                  anchorEl={copyNamePopoverAnchor}
                  onClose={() => setCopyNamePopoverAnchor(null)}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}>
                  <div className={classes.copyConfirm}>
                    Данные скопированы
                  </div>
                </Popover>
              </div>}
            <span className={classes.blackText}>{clientName}</span>
          </div>
          {/* <a href={clientUrl} style={{ display: 'contents' }} className={classes.noLinkStyle} rel="noopener noreferrer">
            <IconButtonMain color='noBgGray' icon={<ArrowRight />} />
          </a> */}
        </div> :
        <div className={clsx(classes.colContainer, classes.nameWidth)}>
          {clientType &&
            <div className={classes.copyBox}>
              <span className={classes.grayText}>{clientType}</span>
              <IconButtonMain
                title='Скопировать'
                style={{ width: '16px', height: '16px' }}
                handleClickEvent={(e) => handleCopyClientName(e)}
                color="noBgTransparent" icon={<CopyIcon />} />
              <Popover
                open={Boolean(copyNamePopoverAnchor)}
                anchorEl={copyNamePopoverAnchor}
                onClose={() => setCopyNamePopoverAnchor(null)}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}>
                <div className={classes.copyConfirm}>
                  Данные скопированы
                </div>
              </Popover>
            </div>}
          <span className={classes.blackText}>{clientName}</span>
        </div>}
      <div className={clsx(classes.colContainer, classes.smallWidth)}>
        <div className={classes.copyBox}>
          <span className={classes.grayText}>ИНН</span>
          <IconButtonMain
            title='Скопировать'
            style={{ width: '16px', height: '16px' }}
            handleClickEvent={(e) => handleCopyInn(e)}
            color="noBgTransparent" icon={<CopyIcon />} />
          <Popover
            open={Boolean(copyInnPopoverAnchor)}
            anchorEl={copyInnPopoverAnchor}
            onClose={() => setCopyInnPopoverAnchor(null)}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}>
            <div className={classes.copyConfirm}>
              Данные скопированы
            </div>
          </Popover>
        </div>
        <span className={classes.blackText}>{inn}</span>
      </div>
      <div className={clsx(classes.colContainer, classes.regionWidth)}>
        <span className={classes.grayText}>Регион</span>
        <span className={classes.blackText}>{region}</span>
      </div>
      <div className={clsx(classes.colContainer, classes.smallWidth)}>
        <span className={classes.grayText}>Время</span>
        <span className={classes.blackText}>{time}</span>
      </div>
      {/* {!isMobile &&
        <a href={clientUrl} style={{ display: 'contents' }} className={classes.noLinkStyle} rel="noopener noreferrer">
          <IconButtonMain color='noBgGray' icon={<ArrowRight />} />
        </a>} */}
    </div>
  )
}

export default memo(ClientCard)
